// 课程列表
const productList = () => import('@/pages/arkHome/productList.vue');
const guidanceList = () => import('@/pages/arkHome/guidanceList.vue');
const productListFromBank = () => import('@/pages/arkHome/productListFromBank.vue');
const hotSaleList = () => import('@/pages/arkHome/hotSaleList.vue');
const projectCourseList = () => import('@/pages/arkHome/projectCourseList.vue');
const producIdtList = () => import('@/pages/arkHome/producIdtList.vue');
export default [
  {
    path: '/productList',
    name: 'productList',
    component: productList,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/producIdtList',
    name: 'producIdtList',
    component: producIdtList,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/productList-from-bank',
    component: productListFromBank,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/guidanceList',
    component: guidanceList,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/hotSaleList',
    component: hotSaleList,
    meta: {
      title: '课程列表',
    },
  },
  {
    path: '/projectCourseList',
    component: projectCourseList,
    meta: {
      title: '精品专题课',
    },
  },

];
